import { render, staticRenderFns } from "./CustomerCatalogueList.vue?vue&type=template&id=3d183b1b&scoped=true&"
import script from "./CustomerCatalogueList.vue?vue&type=script&lang=js&"
export * from "./CustomerCatalogueList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCatalogueList.vue?vue&type=style&index=0&id=3d183b1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d183b1b",
  null
  
)

export default component.exports